'use strict';

exports.__esModule = true;

var _ramda = /*#__PURE__*/require('ramda');

var _isFinite = /*#__PURE__*/require('../../isFinite');

var _isFinite2 = /*#__PURE__*/_interopRequireDefault(_isFinite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isIntegerPolyfill = /*#__PURE__*/(0, _ramda.both)(_isFinite2.default, /*#__PURE__*/(0, _ramda.converge)(_ramda.equals, [Math.floor, _ramda.identity]));

exports.default = isIntegerPolyfill;


//////////////////
// WEBPACK FOOTER
// ./~/ramda-adjunct/lib/internal/polyfills/Number.isInteger.js
// module id = 876
// module chunks = 168707334958949